<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增事件</el-button>
            <el-button
              slot="ctrl-button-after"
              type="primary"
              @click="doExport('0')"
              >导出
            </el-button>
          </div>
        </zv-table>
        <zv-dialog-export
          :showExportDialog.sync="showExportDialog"
          @on-export-current="doExport('0')"
          @on-export-allpage="doExport('1')"
        >
        </zv-dialog-export>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import dataAnalysisApi from "@/views/data-analysis/api";
export default {
  name: "EventList",
  mixins: [addFormMixin],
  components: {},
  data() {
    let vm = this;
    return {
      table: {
        api: api.eventList,
        query: {
        },
        searchData: [
          {
            type: "input",
            model: "event_name",
            placeholder: "事件标题"
          },
          {
            type: "select",
            model: "event_risk_id",
            placeholder: "事件类型",
            api: dataAnalysisApi.riskTypeList,
            query: {
              page: 1,
              pagesize: vm.$enums.allPageSize
            },
            keyValueName: ["id", "risk_name"]
          }
        ],
        customSearchData: [
          {
            title: "事件ID",
            type: "input",
            model: "event_id",
            placeholder: "支持多个ID筛选，用英文逗号隔开",
          },
          {
            title: "减分项",
            type: "select",
            model: "event_related_positive_affect",
            placeholder: "是否减分",
            option: [{
              label: '非减分事件',
              value: -1
            }, {
              label: '减分事件',
              value: 2
            },
             {
              label: '正面减分事件',
              value: 1
            },
            {
              label: '负面减分事件',
              value: 0
            }]
          },
          {
            title: "事件涉华",
            type: "select",
            model: "related2china",
            placeholder: "影响范围",
            option: [{
              label: '是',
              value: 1
            }, {
              label: '否',
              value: 0
            }]
          },
          {
            title: "发生状态",
            type: "select",
            model: "event_happen_status",
            placeholder: "请选择发生状态",
            option: [{
              label: '进行中',
              value: 1
            }, {
              label: '结束',
              value: 2
            }]
          },
          {
            title: "影响状态",
            type: "select",
            model: "event_effect_status",
            placeholder: "请选择影响状态",
            option: [{
              label: '影响中',
              value: 1
            }, {
              label: '结束',
              value: 2
            }]
          },
          {
            title: "影响范围",
            type: "select",
            model: "event_affect_area_type",
            placeholder: "影响范围",
            option: vm.$enums.AreaType.forEventList
          },
          {
            title: "事发地址",
            type: "select",
            model: "event_affect_area_id",
            placeholder: "事发地址",
            api: dataAnalysisApi.areaList,
            query: {
              page: 1,
              pagesize: vm.$enums.allPageSize
            },
            keyValueName: ["id", "full_area_name"]
          },
          {
            title: "发布人",
            type: "select",
            model: "author",
            placeholder: "发布人",
            api: api.authorList,
            query: {
              page: 1,
              pagesize: vm.$enums.allPageSize
            },
            keyValueName: ["username", "username"]
          },
          {
            title: "事发时间",
            type: "dateSection",
            isShowHMS: true,
            sPlaceHolder: '事发开始时间',
            ePlaceHolder: '事发结束时间',
            modelName: ["event_time_start_begin", "event_time_start_end"],
            width: '450px'
          },
          {
            title: "录入时间",
            type: "dateSection",
            isShowHMS: true,
            sPlaceHolder: '录入开始时间',
            ePlaceHolder: '录入结束时间',
            modelName: ["add_time_begin", "add_time_end"],
            width: '450px'
          }
        ],
        columns: [
          {
            title: "事件标题",
            key: "event_name",
            minWidth: "180"
          },
          {
            title: "事件发生地址",
            key: "target_type",
            minWidth: "150",
            render(h, ctx) {
              let event_area = ctx.row.event_area;
              let retVal = "--";
              if (event_area && event_area.length) {
                retVal = event_area.map(item => item.full_area_name).join(",");
              }
              return h("span", retVal);
            }
          },
          {
            title: "事发时间",
            key: "event_time_start",
            minWidth: "110",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h(
                "span",
                vm.$commFunc.formatDate(ctx.row.event_time_start)
              );
            }
          },
          {
            title: "事件类型",
            key: "event_risk",
            render(h, ctx) {
              let event_risk = ctx.row.event_risk;
              let retVal = "--";
              if (event_risk && event_risk.length) {
                retVal = event_risk.map(item => item.full_risk_name).join(",");
              }
              return h("span", retVal);
            }
          },
          {
            title: "影响范围性质",
            key: "event_affect_area_type",
            showTooltip: true
          },
          {
            title: "是否涉华",
            key: "related2china",
            render(h, ctx) {
              return h("span", ctx.row.related2china == 1 ? "是" : "否");
            }
          },
          {
            title: "录入时间",
            key: "add_time",
            minWidth: "150",
            showTooltip: true,
            sortable: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            render(h, ctx) {
              const lookBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doLook.bind(this, ctx.row)
                  }
                },
                "查看"
              );

              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "更新"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(lookBtn);
              arr.push(editBtn);
              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ],
        sortChange: vm.sortChange
      },
      formDataOri: {
        event_name: "",
        is_open: true
      },
      formRules: {
        event_name: [
          {
            required: true,
            message: "事件名称不能为空",
            trigger: "blur"
          }
        ]
      },
      adddApi: api.addEvent,
      editApi: api.editEvent,
      deleteApi: api.deleteEvent,
      addSuccessMsg: "添加事件成功",
      editSuccessMsg: "编辑事件成功",
      deleteSuccessMsg: "删除事件成功",
      deleteKey: "event_id",
      riskTypeData: [],
      nowId: ''
    };
  },

  computed: {
    
  },
  watch: {
    // 'table.data': {
    //   handler(newName, oldName) {
    //     if(sessionStorage.getItem("times")) {
    //       if(newName.length > 0) {
    //         this.tagBindFn(newName[0].id)
    //       }
    //     }
    //   },
    // }
  },

  methods: {
    sortChange(column, prop, order) {
      let sortQuery = ''

      if (prop == 'add_time') {
        if (order == 'ascending') {
          sortQuery = 1
        } else if (order == 'descending') {
          sortQuery = 2
        }
      }

      if (prop == 'event_time_start') {
        if (order == 'ascending') {
          sortQuery = 3
        } else if (order == 'descending') {
          sortQuery = 4
        }
      }

      if (sortQuery) {
        this.table.query.order_type = sortQuery
      }

      this.$refs.dataTable.refresh()
    },
    doAdd() {
      // this.$router.push({
      //   name: 'createEvent'
      // })
      let routeData = this.$router.resolve('/data-input/createEvent')
      window.open(routeData.href, '_blank');
    },
    async doChangeStatus(status, id) {
      await this.editApi({
        id,
        is_open: status
      });
      this.$refs.dataTable.refresh();
      this.$message("状态修改成功!");
    },
    doEdit(editItem) {
      let routeData = this.$router.resolve('/data-input/createEvent?id=' + editItem.id)
      window.open(routeData.href, '_blank');
    },
    
    // 1.3新增 2020.6.16
    doLook(editItem) {
      let routeData = this.$router.resolve('/data-input/createEvent?id=' + editItem.id + '&model=look')
      window.open(routeData.href, '_blank');
    },
    /**
     * @Author: 郑勇波
     * @Desc:导出数据
     */
    doExport(index) {
      this.showExportDialog = false;
      let query = {}
      if (index == "0") {
        query = this.$_.cloneDeep(this.table.query);
        query.pageNo = this.table.pagination.pageNo;
        // query.pageSize = this.table.pageSize;
        query.pageSize = this.table.pagination.total;
        query.export2excel = 1
        // 导出当前页数据
        // api.simCardPage(query);
      } else if (index == "1") {
        query = {
          export2excel: 1,
          pageNo: 1,
          pageSize: 99999
        }
        // 导出全部数据
        // api.simCardAll(query);
      }
      api.exportEventList(query)
    },
    // 1.3 新增
    // async tagBindFn(id) {
    //   let res = await api.tagBind({
    //     session_id: sessionStorage.getItem("times"),
    //     event_id: id
    //   });
    //   console.log(res)
    //   if(res.error_code == 0) {
    //     sessionStorage.removeItem("times")
    //   }
    // }
  },

  created() {
  },

  mounted() {
    
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped></style>
